import WCCSliderItem from "../base/base.model";

export default class WCCSliderDynamicItem<T> extends WCCSliderItem<T> {
    component = 'wcc-slider-item-dynamic';

    borrowed = ko.observable(false).extend({ deferred: true });
    borrowedWidth = ko.observable<number>(0).extend({ deferred: true });

    override getWidth(): number {
        return this.borrowed() ? this.borrowedWidth() : this.width();
    }
}